import * as React from 'react'
import styled from 'styled-components'

import * as ds from '@bob/design-system'
import { styles as S } from '@bob/design-system'

import * as entity from '@boutique/entities'
import * as richtext from '@bob/rich-text'

type DescriptionProps = {
  brand: entity.brand.Brand
}

export function Description({ brand }: DescriptionProps): React.ReactElement<DescriptionProps> {
  return (
    <Section>
      {brand.description && <S.heading.Title3 as="h2">À propos</S.heading.Title3>}
      {brand.claim && <Claim>{brand.claim}</Claim>}
      <richtext.RichText document={brand.description?.json} />
    </Section>
  )
}

const Claim = styled(S.wysiwyg.Claim)``

const Section = styled.section`
  margin-top: 40px;

  ${S.heading.Title3} {
    margin-bottom: 35px;
  }
  ${ds.MediaLoader} {
    margin: 37px auto 66px;

    ${ds.BlobPicture} {
      ${S.picture.Picture} {
        @media not screen and (${ds.breakpoint.MOBILE_M}) {
          width: 280px;
          height: 280px;
        }
      }
    }
  }
`
